export enum FixedItemOptionStatus {
  なし,
  月数,
  金額,
  割合,
  家賃に含む
}
